import { initializeAllCategoriesState } from '../state/app.state';
import { createReducer, on, Action } from '@ngrx/store';
import * as fromCategoryAction from '../action/all-categories.action';
import { ICategoriesData } from '@app/@shared/Models/all-categories.model';

export const initialOrderState: ICategoriesData = initializeAllCategoriesState();

const reducer = createReducer(
    initialOrderState,
    on(fromCategoryAction.AllCategoriesSuccess, (state: ICategoriesData, { payload }) => {
        return { ...state, AllCategoriesResponse: payload };
    }),
    on(fromCategoryAction.AllCategoriesError, (state, { payload }
    ) => {
        return { ...state, error: payload };
    })
);

export function AllCategoriesReducer(state: ICategoriesData | undefined, action: Action) {
    return reducer(state, action);
}  